export const ERROR_CODES_MSG = {
  CUSEXP1: 'search.error-code.message.policy-not-supported',
  CUSEXP2: 'search.error-code.message.cannot-locate-pol',
  CUSEXP3: 'search.error-code.message.cannot-locate-pol',
  CUSEXP7: 'search.error-code.message.multiple-mdm',
  RESEXP1: 'reactivate.error-code.message.not-registered',
  REAEXP2: 'reactivate.error-code.message.unknown-error',
  REAEXP: 'reactivate.error-code.message.unknown-error',
};

export const SERVER_ERROR_CODES = ['CUSEXP1', 'CUSEXP2', 'CUSEXP3', 'CUSEXP7', 'RESEXP1', 'REAEXP2', 'REAEXP'];

export const TERMS_CONST = {
  terms: 'term-conditions',
  pics: 'pics',
};

// For EMMMA forget username
export const EMMA_ERROR_CODES_MSG = {
  CUSEXP1: ['emma.retrieve-account.error-message.expired',
    'emma.retrieve-account.error-message.expired2'],
  CUSEXP2: ['emma.retrieve-account.error-message.cannot-find-policy',
    'emma.retrieve-account.error-message.cannot-find-policy2'],
  CUSEXP3: [
    'emma.retrieve-account.error-message.wrong-dob',
    'emma.retrieve-account.error-message.ask-to-check',
  ],
  CUSEXP4: ['emma.retrieve-account.error-message.expired',
    'emma.retrieve-account.error-message.expired2'],
  CUSEXP5: ['emma.retrieve-account.error-message.expired',
    'emma.retrieve-account.error-message.expired2'],
  CUSEXP7: ['emma.retrieve-account.error-message.mdm',
    'emma.retrieve-account.error-message.mdm2'],
  CUSEXP9: ['emma.retrieve-account.error-message.hsbc'],
  CUSEXP10: ['emma.retrieve-account.error-message.no-contact',
    'emma.retrieve-account.error-message.expired2'],
  CUSEXP23: ['emma.retrieve-account.error-message.CUSEXP23.message1',
    'emma.retrieve-account.error-message.CUSEXP23.message2'],
  CUSEXP: ['emma.retrieve-account.error-message.unknown',
    'emma.retrieve-account.error-message.unknown2'],
  RESEXP1: ['emma.retrieve-account.error-message.unavailable'],
  RESEXP2: ['emma.retrieve-account.error-message.unavailable'],
  RESEXP3: ['emma.retrieve-account.error-message.contact-used1'],
  RESEXP: ['emma.retrieve-account.error-message.unavailable'],
  CUSTOM_ERROR_RETRIEVE_ACCOUNT_DONT_MATCH_MDMID: [
    'emma.retrieve-account.error-message.cannot-find-policy',
    'emma.retrieve-account.error-message.ask-to-create-account',
  ],
  CUSTOM_ERROR_RETRIEVE_ACCOUNT_MDMID_WITHOUT_AXAID: [
    'emma.retrieve-account.error-message.have-no-emma-account',
    'emma.retrieve-account.error-message.ask-to-create-account',
  ],
  CUSTOM_ERROR_RETRIEVE_ACCOUNT_INACTIVE_ACCOUNT: [
    'emma.retrieve-account.error-message.inactive-account',
  ],
  CUSTOM_ERROR_RETRIEVE_ACCOUNT_GENERAL_ERROR: [
    'emma.retrieve-account.error-message.unknown',
  ],
};
export const myAXA = { title: 'MyAXA', items: [], hightlights: [] };
export const DEF_REDIRECT = 'login';

export const USER_TYPE_OWNER_AND_INSURED = 'full';
export const USER_TYPE_ONLY_OWNER = 'owner';
export const USER_TYPE_ONLY_INSURED = 'insured';
export const USER_TYPE_CWP = 'cwp';
export const USER_TYPE_UNDEFINED = 'undefined';

export const CHATBOT_ERROR_CODES = {
  REGISTRATION: {
    ACTIVATION_TOKEN_EXPIRED_FOR_24_HOURS: 'CUSEXP43',
    ACTIVATION_TOKEN_EXPIRED_FOR_7_DAYS: 'CUSEXP42',
    ACTIVATION_FAILED_FOR_UNKNOWN_REASON: 'CUSEXP44',
    REACTIVATION_FAILED_FOR_UNKNOWN_REASON: 'CUSEXP47',
  },
  COMMON: {
    INVALID_LINK: 'FPEXP5',
  },
};

export const POLICY_TYPES = {
  company: 'company',
  individual: 'individual',
  pnc: 'pnc',
};

export const ROUTE_NAMES = {
  company: 'employee-benefit',
  individual: 'individual-policy',
  pnc: 'property-and-casualty',
};

export const POLICY_TYPE_LIFE = 'life';
export const POLICY_TYPE_EB = 'eb';
export const POLICY_TYPE_PNC = 'pnc';

export const CARD_TYPE_ID_CARD = 'hkid'; // do not change to hkId as it will break api
export const CARD_TYPE_PASSPORT = 'passport';
export const CARD_TYPE_CHINA_ID = 'chinaId';
export const CARD_TYPE_MACAU_ID = 'macauId';
export const CARD_TYPE_AXA_CARD = 'axa';
export const CARD_TYPE_OTHER_CARD = 'other';

export const POLICY_LEN_PNC = 8;

// should match featureCode in api-codes.json
export const FEATURE_CODES = {
  registration: 'CUS',
  findMyPolicy: 'FMP',
  forgetUsername: 'RES',
  forgetPassword: 'FPW',
  login: 'LGI',
};

export const POLICY_TYPE_CODES = {
  company: 'EB',
  individual: 'LF',
  pnc: 'PC',
};
